import {type List} from 'immutable';

import {createAction} from 'web-app/util/redux/famly-app-helpers';
import type * as BillPayerModel from 'web-app/react/entities/bill-payers/model';

import type * as Model from './model';

const domain = 'BILLING_OVERVIEW';

export const {
    action: fetchFamlyBillPayersInfo,
    success: fetchFamlyBillPayersInfoSuccess,
    failed: fetchFamlyBillPayersInfoFailed,
} = createAction(
    `${domain}/FETCH_FAMLY_BILL_PAYERS`,
    () => ({}),
    (famlyBillPayersInfo: List<Model.FamlyBillPayerInfo>, showNotification: boolean) => ({
        famlyBillPayersInfo,
        showNotification,
    }),
);

export const {
    action: fetchBalance,
    success: fetchBalanceSuccess,
    failed: fetchBalanceFailed,
} = createAction(
    `${domain}/FETCH_BALANCE`,
    (institutionId: string, billPayerId: string) => ({
        institutionId,
        billPayerId,
    }),
    (balance: string, billingActivityItems: List<Model.BillingActivityItem>) => ({
        balance,
        billingActivityItems,
    }),
);

export const {action: updateFamlyBillPayer} = createAction(
    `${domain}/UPDATE_FAMLY_BILL_PAYER`,
    (billPayer: BillPayerModel.BillPayer) => ({
        billPayer,
    }),
);
